import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  height: 100%;
  overflow-y: auto;
  padding: 1.5rem;
  justify-content: center;
  align-items: center;
  display: flex;
  flex-direction: column;
`;

export const Grid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 4rem;
`;

export const LabelButton = styled.label`
  width: 250px;
  height: 200px;
  background-color: var(--black-200);
  margin-top: 31px;
  margin-bottom: 31px;
  border-radius: 10px;
  cursor: pointer;
  border: 2px dashed var(--grey-300);
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;

  input {
    display: none;
  }

  p {
    width: fit-content;
    font-weight: 500;
  }

  &:last-of-type {
    border: 2px dashed var(--primary);
    color: var(--primary);
  }
`;
